import { createContext } from 'react';

const SiteContentContext = createContext(null);

export default SiteContentContext;
